import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles, tag } from './item.styles';

@customElement(tag)
export class ItemComponent extends TmElement {
  static override styles = styles;

  @property({ type: Boolean, reflect: true })
  spacer = false;

  override connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'listitem');
  }

  override render() {
    return html`<li part="content" role="none"><slot></slot></li>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-list-item': ItemComponent;
  }
}
